import { SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

import { FiltroInput } from './styles';

let searchInput;

const filterDropdown = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
}) => (
  <div style={{ padding: 8 }}>
    <FiltroInput
      aria-label="inputSearch"
      ref={node => {
        searchInput = node;
      }}
      value={selectedKeys?.length ? selectedKeys[0] : ''}
      onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={confirm}
    />
    <Button
      type="primary"
      onClick={confirm}
      icon={<SearchOutlined />}
      style={{ marginRight: 5 }}
    >
      Pesquisar
    </Button>
    <Button className="btn-limpar" onClick={clearFilters}>
      Limpar
    </Button>
  </div>
);

const filterIcon = filtered => (
  <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
);

const onFilterDropdownVisibleChange = visible =>
  visible && setTimeout(() => searchInput.select());

export const getColumnSearchProps = () => ({
  filterDropdown,
  filterIcon,
  onFilterDropdownVisibleChange,
});
